<template>
  <router-link
    :to="route"
    class="tw:pt-4 tw:relative tw:text-nowrap tw:w-auto tw:text-sm tw:flex tw:mt-4 tw:lg:inline-block tw:items-center tw:lg:mt-0 tw:pb-3 tw:hover:text-blue-700 tw:px-3 tw:py-2 tw:border-b-4 tw:hover:border-blue-700"
    :class="
      isLinkActive ? 'tw:font-bold tw:border-blue-700 tw:text-blue-700' : 'tw:border-transparent tw:text-gray-800'
    "
  >
    <slot />
  </router-link>
</template>
<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
const router = useRouter()
const props = defineProps({
  route: {
    type: String,
    required: true,
  },
})

const isLinkActive = computed(() => {
  let currentRoute
  if (router.currentRoute.value.path === '/rate-connect/running/smart-boost-history') {
    currentRoute = '/rate-connect/running/smart-boost'
  } else if (router.currentRoute.value.path === '/billing/subscriptions/details') {
    currentRoute = '/billing/subscriptions'
  } else if (router.currentRoute.value.path === '/billing/payment-methods/edit-payment') {
    currentRoute = '/billing/payment-methods'
  } else {
    currentRoute = router.currentRoute.value.path
  }

  return props.route.replace('/home', '') === currentRoute
})
</script>
<style scoped>
a:hover {
  text-decoration: none;
}
</style>
